import classNames from "classnames";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { createRef, useState } from "react";
import { BsCamera } from "react-icons/bs";
import { FiUpload } from "react-icons/fi";
import { IoRefresh } from "react-icons/io5";
import Webcam from "react-webcam";

function WebCamDialog(props) {
  const webCamInput = createRef();
  const [selfieDialog, setSelfieDialog] = useState(null);
  const [selfieURL, setSelfieURL] = useState('')
  const fileName = `SelfieN${Math.random() * 1000000000}.jpeg`

  const webCamFooter = (
    <div className="justify-center flex mt-2 w-full">
      {!selfieDialog ? <Button
        className="w-1/3"
        icon={<BsCamera/>}
        label="Tirar foto"
        onClick={() => base64toFile(webCamInput.current.getScreenshot())}
      /> :
        <div className="flex w-full justify-center gap-6">
          <Button
            className="w-1/3"
            label="Enviar"
            severity="success"
            icon={<FiUpload/>}
            onClick={() => props.upload(selfieDialog)}
          />
          <Button
            className="w-1/3"
            label="Tirar outra foto"
            severity="warning"
            icon={<IoRefresh/>}
            onClick={() => setSelfieDialog(null)}
          />
        </div>}
    </div>
  )

  const base64toFile = async (imageBase64) => {
    setSelfieURL(imageBase64)
    const res = await fetch(imageBase64);
    const blob = await res.blob();
    // console.log(new File([blob], fileName, { type: 'image/jpeg' }))
    const selfie_file = new File([blob], fileName, { type: 'image/jpeg' });
    setSelfieDialog(selfie_file)
  }

  return (
    <Dialog
      visible={props.visible}
      onHide={() => props.close()}
      header="Tirar Selfie"
      maximized
      pt={{
        root: ({ state }) => ({
          className: classNames('rounded-lg shadow-lg border-0',
            'max-h-screen transform scale-100',
            'm-0 w-[90vw]',
            'dark:border dark:border-blue-900/40', {
            'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized
          })
        }),
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80 h-[10vh] text-2xl text-center'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full h-[72vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            //'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow h-[80vh]": state.maximized
          })
        }),
        // footer: {
        //   className: classNames('shrink-0 ', 
        //     'h-[12vh]',
        //     'border-t-0 bg-white text-gray-700 text-right rounded-b-lg', 
        //     'dark:bg-gray-900  dark:text-white/80')
        // },
      }}
      footer={webCamFooter}
    >
      <div className="justify-center flex w-full">
        <div className="grid w-full lg:w-1/2 text-center">
          <h4 className="text-xl font-semibold">Posicione o seu rosto no centro da imagem, certifique-se de estar num lugar iluminado
            para garantir melhores resultados, procure tirar uma foto apenas do seu rosto
          </h4>
          {!selfieDialog ? <Webcam
            audio={false}
            width={'100%'}
            height={'100%'}
            ref={webCamInput}
            autoPlay={true}
            screenshotFormat="image/jpeg"
          /> : <img
            src={selfieURL}
            width={window.innerWidth > 720 ? window.innerWidth * 3 / 5 : window.innerWidth}
            // height={window.innerHeight*3/5}
            alt="selfie_dialog"
          />}

        </div>
      </div>
    </Dialog>
  )
}

export default WebCamDialog